export default {
    'gender_1,2': 'Male/Female',
    gender_1: 'Male',
    gender_2: 'Female',
    gender_3: 'Both',
    gender_5: 'Other',
    gender_9999: 'DTR/Unknown',
    gender_10000: 'All',

    full_gender_1: 'Male',
    full_gender_2: 'Female',
    full_gender_3: 'Both Sexes',
    full_gender_5: 'Other',
    full_gender_9999: 'DTR/Unknown',
    full_gender_10000: 'All',
};
